import { gql, TypedDocumentNode } from '@apollo/client';

export const stateTerritoryFragment = gql`
  fragment stateTerritory on State {
    slug
    stateterritoryLabel
    regionsCollection(limit: 10) {
      items {
        ...region
      }
    }
  }
`;

export const regionFragment = gql`
  fragment region on Region {
    sys {
      ...sys
    }
    slug
    name
    areasCollection(limit: 15) {
      items {
        ...area
      }
    }
  }
`;

export const areaFragment = gql`
  fragment area on Area {
    sys {
      ...sys
    }
    slug
    name
    suburbsCollection(limit: 10) {
      items {
        ...suburb
      }
    }
  }
`;

export const suburbFragment = gql`
  fragment suburb on Suburb {
    slug
    name
  }
`;

// Reverse lookup from suburb
export const locationFragment = gql`
  fragment location on Suburb {
    slug
    name
    linkedFrom {
      areaCollection(limit: 1) {
        items {
          slug
          name
          linkedFrom {
            regionCollection(limit: 1) {
              items {
                slug
                name
                linkedFrom {
                  stateCollection(limit: 1) {
                    items {
                      slug
                      stateterritoryLabel
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
` as TypedDocumentNode;
